import JobService from "./job/JobService";
import SlaViewService from "./sla-view/SlaViewService";
import AuthService from "./auth/AuthService";
import ReportService from "./report/reportService";
import UtilitiesService from './util';
const JobServiceApi = new JobService();
const SlaViewServiceApi = new SlaViewService();
const AuthServiceApi = new AuthService();
const ReportServiceApi = new ReportService();
const Util = new UtilitiesService();

export {
    JobServiceApi,
    SlaViewServiceApi,
    AuthServiceApi,
    ReportServiceApi,
    Util,
}